import { displayData, noData } from "./../stores.js";

export function getGroupsFromCountries(countrydata) {
  countrydata = Object.entries(countrydata).map((d) => d[1]);
  const incomegroups = [...new Set(countrydata.map((item) => item.income))];
  const regions = [...new Set(countrydata.map((item) => item.wbregion))];
  const lending = [...new Set(countrydata.map((item) => item.lendingcat))];
  const fragile = [...new Set(countrydata.map((item) => item.fragile))];

  let groups = [{ value: "All", label: "All countries" }];
  groups = groups
    .concat(
      incomegroups.map((d) => {
        return { value: d, label: d, group: "Income group" };
      })
    )
    .concat(
      regions.map((d) => {
        return { value: d, label: d, group: "Region" };
      })
    )
    .concat(
      lending.map((d) => {
        return { value: d, label: d, group: "Lending" };
      })
    )
    .concat(
      fragile.map((d) => {
        return { value: d, label: d, group: "Fragile" };
      })
    ).filter(d => d.value !== '')
    .filter(d => d.value != 'NA');
  return groups;
}

export function prepareScatterData(
  xdata,
  ydata,
  year,
  countrydata,
  activegroup,
  mostrecent
) {
  if (Object.keys(countrydata).length !== 0){
  let countries = Object.keys(xdata).filter((d) =>
    Object.keys(ydata).includes(d)
  );

  let scatterdata = countries.map((cntr) => {
    let mostRecentX = Object.keys(xdata[cntr])
      .map((d) => d.replace("year_", ""))
      .sort(function (a, b) {
        return b - a;
      })[0];
    let mostRecentY = Object.keys(ydata[cntr])
      .map((d) => d.replace("year_", ""))
      .sort(function (a, b) {
        return b - a;
      })[0];

    if (
      xdata[cntr].hasOwnProperty(`year_${mostrecent ? mostRecentX : year}`) &&
      ydata[cntr].hasOwnProperty(`year_${mostrecent ? mostRecentY : year}`)
    ) {
      let obj = {};
      obj.value = cntr;
      obj.label = cntr;
      obj.x = xdata[cntr][`year_${mostrecent ? mostRecentX : year}`];
      obj.xYear = mostrecent ? mostRecentX : year;
      obj.y = ydata[cntr][`year_${mostrecent ? mostRecentY : year}`];
      obj.yYear = mostrecent ? mostRecentY : year;
      obj.wbcode = countrydata[cntr]["wbcode"];
      obj.wbregion = countrydata[cntr]["wbregion"];
      obj.income = countrydata[cntr]["income"];
      obj.fragile = countrydata[cntr]["fragile"];
      obj.lending = countrydata[cntr]["lending"];
      return obj;
    } else {
      return "No data";
    }
  });
  let returnData = scatterdata.filter((d) => d !== "No data");

  if (typeof activegroup === "undefined") {
    displayData.set(false);
    if (returnData.length === 0) {
      noData.set(true);
    } else {
      noData.set(false);
    }
    return returnData;
  } else {
    displayData.set(true);
  }

  if (activegroup.group === "Income group") {
    returnData = returnData.filter((d) => d.income === activegroup.label);
  }
  if (activegroup.group === "Region") {
    returnData = returnData.filter((d) => d.wbregion === activegroup.label);
  }
  if (activegroup.group === "Fragile") {
    returnData = returnData.filter((d) => d.fragile === activegroup.label);
  }
  if (activegroup.group === "Lending") {
    returnData = returnData.filter((d) => d.lending === activegroup.label);
  }
  if (returnData.length === 0) {
    noData.set(true);
  } else {
    noData.set(false);
  }
  return returnData;
}
else{return []}
}

export function prepareLineData(ydata, countrydata, activegroup) {
  let countries = Object.keys(ydata);
  if (Object.keys(countrydata).length !== 0) {
    let returnData = countries.map((cntr) => {
      if (cntr !== "") {
        let obj = {};
        obj.value = cntr;
        obj.label = cntr;
        obj.wbcode = countrydata[cntr]["wbcode"];
        obj.wbregion = countrydata[cntr]["wbregion"];
        obj.income = countrydata[cntr]["income"];
        obj.fragile = countrydata[cntr]["fragile"];
        obj.lending = countrydata[cntr]["lending"];
        obj.values = Object.keys(ydata[cntr]).map((d) => {
          let yrObject = {};
          yrObject.year = +d.replace("year_", "");
          yrObject.value = ydata[cntr][d];
          return yrObject;
        });
        return obj;
      }
    });
    returnData = returnData
      .filter((d) => d !== undefined)
      .filter((d) => d.values.length > 0);

    if (typeof activegroup === "undefined") {
      displayData.update(() => false);
      return returnData;
    } else {
      displayData.update(() => true);
    }

    if (activegroup.group === "Income group") {
      returnData = returnData.filter((d) => {
        return d.income === activegroup.label;
      });
    }
    if (activegroup.group === "Region") {
      returnData = returnData.filter((d) => d.wbregion === activegroup.label);
    }
    if (activegroup.group === "Fragile") {
      returnData = returnData.filter((d) => d.fragile === activegroup.label);
    }
    if (activegroup.group === "Lending") {
      returnData = returnData.filter((d) => d.lending === activegroup.label);
    }
    return returnData;
  }
  else{ return []}
}

function getYearValue(srcValues, mostrecent, year) {
  let mostRecentYear = getYear(srcValues, mostrecent, year);
  if (srcValues.hasOwnProperty(`year_${mostrecent ? mostRecentYear : year}`)) {
    return srcValues[`year_${mostrecent ? mostRecentYear : year}`];
  } else {
    return "No data";
  }
}
function getYear(srcValues, mostrecent, year) {
  let mostRecentYear = Object.keys(srcValues)
    .map((d) => d.replace("year_", ""))
    .sort(function (a, b) {
      return b - a;
    })[0];
  return mostrecent ? mostRecentYear : year;
}

export function prepareBenchmarkData(
  bmdata,
  year,
  countrydata,
  activegroup,
  mostrecent
) {
  if (Object.keys(countrydata).length !== 0){
  let returnData = bmdata.map((inddata) => {
    let countries = Object.keys(inddata).filter((d) => d !== "");
    let indicatorBMData = countries.map((cntr) => {
      let obj = {};
      obj.label = cntr;
      obj.x = getYearValue(inddata[cntr], mostrecent, year);
      obj.year = getYear(inddata[cntr], mostrecent, year);
      obj.wbregion = countrydata[cntr]["wbregion"];
      obj.income = countrydata[cntr]["income"];
      obj.fragile = countrydata[cntr]["fragile"];
      obj.lending = countrydata[cntr]["lending"];
      return obj;
    });
    indicatorBMData = indicatorBMData.filter((d) => d.x !== "No data");

    if (typeof activegroup === "undefined") {
      displayData.update(() => false);
      return indicatorBMData;
    } else {
      displayData.update(() => true);
    }

    if (activegroup.group === "Income group") {
      indicatorBMData = indicatorBMData.filter(
        (d) => d.income === activegroup.label
      );
    }
    if (activegroup.group === "Region") {
      indicatorBMData = indicatorBMData.filter(
        (d) => d.wbregion === activegroup.label
      );
    }
    if (activegroup.group === "Fragile") {
      indicatorBMData = indicatorBMData.filter(
        (d) => d.fragile === activegroup.label
      );
    }
    if (activegroup.group === "Lending") {
      indicatorBMData = indicatorBMData.filter(
        (d) => d.lending === activegroup.label
      );
    }
    return indicatorBMData;
  });
  //returnData = scatterdata.filter((d) => d !== "No data");
  return returnData;
}
}

export function prepareMapData(
  ydata,
  year,
  countrydata,
  mostrecent,
  activegroup
) {
  if (Object.keys(countrydata).length !== 0){
  let countries = Object.keys(ydata);

  let mapdata = countries.map((cntr) => {
    if (
      ydata[cntr].hasOwnProperty(
        `year_${getYear(ydata[cntr], mostrecent, year)}`
      )
    ) {
      let obj = {};
      obj.value = cntr;
      obj.label = cntr;
      obj.wbcode = countrydata[cntr]["wbcode"];
      obj.y = getYearValue(ydata[cntr], mostrecent, year);
      obj.year = getYear(ydata[cntr], mostrecent, year);
      obj.wbregion = countrydata[cntr]["wbregion"];
      obj.income = countrydata[cntr]["income"];
      obj.fragile = countrydata[cntr]["fragile"];
      obj.lending = countrydata[cntr]["lending"];
      return obj;
    } else {
      return "No data";
    }
  });
  let returnData = mapdata.filter((d) => d !== "No data");

  if (typeof activegroup === "undefined") {
    displayData.update(() => false);
    return returnData;
  } else {
    displayData.update(() => true);
  }
  if (activegroup.group === "Income group") {
    returnData = returnData.filter((d) => d.income === activegroup.label);
  }
  if (activegroup.group === "Region") {
    returnData = returnData.filter((d) => d.wbregion === activegroup.label);
  }
  if (activegroup.group === "Fragile") {
    returnData = returnData.filter((d) => d.fragile === activegroup.label);
  }
  if (activegroup.group === "Lending") {
    returnData = returnData.filter((d) => d.lending === activegroup.label);
  }
  return returnData;
}
}

export function prepareBarData(
  ydata,
  year,
  countrydata,
  mostrecent,
  referencecountries,
  primarycountry
) {
  if (Object.keys(countrydata).length !== 0){
  let countries = Object.keys(ydata);
  let refcountries = [];
  if (referencecountries !== null) {
    refcountries = referencecountries.map((cntr) => cntr.label);
  }
  if (primarycountry !== null && typeof primarycountry !== "undefined" ) {
    refcountries.push(primarycountry.label)
  }

  let mapdata = countries.map((cntr) => {
    if (
      ydata[cntr].hasOwnProperty(
        `year_${getYear(ydata[cntr], mostrecent, year)}`
      )
    ) {
      let obj = {};
      obj.value = cntr;
      obj.label = cntr;
      obj.wbcode = countrydata[cntr]["wbcode"];
      obj.x = getYearValue(ydata[cntr], mostrecent, year);
      obj.year = getYear(ydata[cntr], mostrecent, year);
      obj.wbregion = countrydata[cntr]["wbregion"];
      obj.income = countrydata[cntr]["income"];
      obj.fragile = countrydata[cntr]["fragile"];
      obj.lending = countrydata[cntr]["lending"];
      return obj;
    } else {
      return "No data";
    }
  });
  let returnData = mapdata.filter((d) => d !== "No data");
  if (referencecountries) {
    returnData = returnData
      .filter((d) => refcountries.includes(d.label))
      .sort((a, b) => {
        return a.x - b.x;
      });
    return returnData;
  } else {
    return [];
  }
}
}

export function scatterToDownloadData(scatterdata, xvariable, yvariable) {
  return scatterdata.map((d) => {
    return {
      country: d.label,
      wbregion: d.wbregion,
      wbincome: d.income,
      fragile: d.fragile,
      lending: d.lending,
      xVariable: xvariable.value,
      xValue: d.x,
      xYear: d.xYear,
      yVariable: yvariable.value,
      yValue: d.y,
      yYear: d.yYear,
    };
  });
}

export function lineToDownloadData(linedata, yvariable) {
  let dldata = [];
  linedata.forEach((cntr) => {
    let cntrDlData = cntr.values.map((d) => {
      return {
        country: cntr.label,
        wbregion: cntr.wbregion,
        wbincome: cntr.income,
        fragile: cntr.fragile,
        lending: cntr.lending,
        yVariable: yvariable.value,
        year: d.year,
        value: d.value,
      };
    });
    dldata = dldata.concat(cntrDlData);
  });
  return dldata;
}

export function benchmarkToDownloadData(benchmarkdata, benchmarkvalue) {
  let dldata = [];
  if (benchmarkvalue === null || typeof benchmarkdata === "undefined") {
    return [];
  } else {
    if (benchmarkdata.length === benchmarkvalue.length) {
      benchmarkvalue.forEach((indicator, i) => {
        let bmdata = benchmarkdata[i].map((d) => {
          return {
            country: d.label,
            wbregion: d.wbregion,
            wbincome: d.income,
            fragile: d.fragile,
            lending: d.lending,
            variable: indicator.value,
            year: d.year,
            value: d.x,
          };
        });
        dldata = dldata.concat(bmdata);
      });
      return dldata;
    }
  }
}

export function mapToDownloadData(mapdata, yvariable) {
  if(typeof mapdata !== "undefined"){
  return mapdata.map((d) => {
    return {
      country: d.label,
      wbcode: d.wbcode,
      wbregion: d.wbregion,
      wbincome: d.income,
      fragile: d.fragile,
      lending: d.lending,
      variable: yvariable.value,
      value: d.y,
      year: d.year,
    };
  });
}
}

export function barToDownloadData(bardata, yvariable) {
  return bardata.map((d) => {
    return {
      country: d.label,
      wbcode: d.wbcode,
      wbregion: d.wbregion,
      wbincome: d.income,
      fragile: d.fragile,
      lending: d.lending,
      variable: yvariable.value,
      value: d.x,
      year: d.year,
    };
  });
}
